import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { NewsResponse, Article } from '../types/api';
import {
  BASE_API_URL,
  GET_NEWS_FOR_MAIN_ENDPOINT,
  GET_ALL_NEWS_ENDPOINT,
} from '../constants/api';

export const newsService = createApi({
  reducerPath: 'newsAPI',
  baseQuery: fetchBaseQuery({ baseUrl: BASE_API_URL }),
  endpoints: (builder) => ({
    getNewsForMain: builder.query<Article[], void>({
      query: () =>
        GET_NEWS_FOR_MAIN_ENDPOINT + process.env.REACT_APP_CURRENTS_API_KEY,
      transformResponse: (response: NewsResponse) => response.news,
    }),
    getAllNews: builder.query<Article[], void>({
      query: () =>
        GET_ALL_NEWS_ENDPOINT + process.env.REACT_APP_CURRENTS_API_KEY,
      transformResponse: (response: NewsResponse) => response.news,
    }),
  }),
});

export const { useGetNewsForMainQuery, useGetAllNewsQuery } = newsService;
